module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "15%",
      "width": "20%",
      "float": "left"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("商家代注册")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("代替客户注册，注册完成后将帐号密码交付客户。")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "设置商家账号"
    },
    model: {
      value: (_vm.ruleForm.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "account", $$v)
      },
      expression: "ruleForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "设置商家账号昵称"
    },
    model: {
      value: (_vm.ruleForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "nickname", $$v)
      },
      expression: "ruleForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "设置登录密码"
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "请再次输入登录密码"
    },
    model: {
      value: (_vm.ruleForm.password2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password2", $$v)
      },
      expression: "ruleForm.password2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("\n                    注册\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "15%",
      "width": "20%",
      "float": "left"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("商家自行注册")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("通过该链接或二维码注册的用户自动划为本客户。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("注册链接地址：")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.reg_add))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("注册二维码：")]), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.logo
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f27aa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/merchant/MerchantRegist.vue
// module id = 1045
// module chunks = 1